$('.select-dropdown').click(function() {
    $(this).closest('.field').toggleClass('select-open');
});

var servicesselected = [];
var servicesloop;
var servicecounter = $('.services-selected');
var servicesinput = $('#services-input');

$( ".service-checkbox" ).change(function() {
servicesselected = [];
servicesinput.val('');

var selectedservices = $( ".service-checkbox:checked" ).length;

if (selectedservices > 0) {
    servicecounter.html(`(${selectedservices})`).show();
}
else {
    servicecounter.hide();
}

    $( ".service-checkbox:checked" ).each(function( index ) {
            var selectedservicevalue = $(this).val();
            servicesselected.push(selectedservicevalue);
    });

    servicesloop = 0;
    for (i in servicesselected) {
        servicesloop = servicesloop + 1;
        servicesinput.val(servicesinput.val() + servicesselected[i]);
        if(servicesselected.length !== servicesloop) {
            servicesinput.val(servicesinput.val() + ', ');
        }
    }
    
});